import redirectInterceptor from "@/interceptors/redirect_interceptor";
import router from "@/router";

const getDefaultState = () => {
  return {
    voyageSpeedData: null,
    fetchLoading: true,
    fetchError: null
  };
};

const state = getDefaultState();

const getters = {
  speedsChartOptions: (state) => {
    return {
      title: {
        text: undefined,
      },
      xAxis: {
        title: {
          text: "kn",
          align: "high",
        },
        min: 0,
        max: 20,
      },
      yAxis: {
        title: {
          text: "Instances",
          align: "high",
        },
      },
      legend: {
        align: "right",
        verticalAlign: "top",
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Speed Over Ground",
          type: "column",
          data: state.voyageSpeedData !== null
            ? state.voyageSpeedData.sog
            : [],
        },
        {
          name: "Speed Through Water",
          type: "column",
          data: state.voyageSpeedData !== null
            ? state.voyageSpeedData.stw
            : [],
        },
      ],
    };
  },
};

const actions = {
  async fetchVoyageSpeedData({ commit }, data) {
    const url = `${process.env.VUE_APP_BASIC_URL}/vesselInformation/${data.name}/voyageSpeedData`;
    const startDate = data.startDate;
    const stopDate = data.stopDate;

    const response = await redirectInterceptor.get(url, {
      params: {
        startDate: startDate,
        stopDate: stopDate
      },
      headers: {
        Authorization: localStorage.getItem("quad_token")
      }
    });
    if (response.status === 200) {
      commit("SET_FETCH_SPEED_DATA_SUCCESS_STATE", response.data);
    } else {
      if (response.data.msg === "rdr") {
        router.push("/login");
      }
      commit("SET_FETCH_SPEED_DATA_ERROR_STATE");
    }
  },
};

const mutations = {
  SET_FETCH_SPEED_DATA_SUCCESS_STATE(state, data) {
    state.voyageSpeedData = data;
    state.fetchLoading = false;
    state.fetchError = null;
  },
  SET_FETCH_SPEED_DATA_LOADING_STATE(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_FETCH_SPEED_DATA_ERROR_STATE(state) {
    state.fetchLoading = false;
    state.fetchError = "Could not fetch speed data";
  },
};

export const voyageSpeedDataModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
